module.exports = "//static.hsappstatic.net/salesImages/static-1.403/self-service/upgrade/upgrade-messages@2x.png"